/**
 * Запускает функцию после загрузки страницы
 *
 * @param fn - передаваемая для запуска функция
 */
export default (fn) => {
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", fn);
	} else {
		fn();
	}
};
